import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { facilityStatusUrl } from '../BaseURL';

const FacilityContext = createContext({
  facility: null,
  configured: false,
  loading: true,
  refresh: () => {},
});

export const FacilityProvider = ({ children }) => {
  const [facility, setFacility] = useState(null);
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(facilityStatusUrl);
      if (res.data?.success) {
        setConfigured(!!res.data.configured);
        setFacility(res.data.facility || null);
      }
    } catch (err) {
      // Backend unreachable — treat as unconfigured so setup is offered
      setConfigured(false);
      setFacility(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <FacilityContext.Provider value={{ facility, configured, loading, refresh }}>
      {children}
    </FacilityContext.Provider>
  );
};

export const useFacility = () => useContext(FacilityContext);
